import { createContext, useContext, useState } from "react";

interface Context {
  isCreating: boolean;
  latLngSelected: L.LatLng | null;
  setIsCreating: (isCreating: boolean) => void;
  setLatLngSelected: (latLng: L.LatLng | null) => void;
}

const CriarManifestacaoContext = createContext<Context>({
  isCreating: false,
  latLngSelected: null,
  setIsCreating: () => null,
  setLatLngSelected: () => null
});

const Provider: React.FC = ({ children }) => {
  const [isCreating, setIsCreating] = useState(false);
  const [latLngSelected, setLatLngSelected] = useState<L.LatLng | null>(null);

  return (
    <CriarManifestacaoContext.Provider
      value={{
        isCreating,
        latLngSelected,
        setLatLngSelected,
        setIsCreating
      }}
    >
      {children}
    </CriarManifestacaoContext.Provider>
  );
};

export const useCriarManifestacao = (): Context =>
  useContext(CriarManifestacaoContext);

export default Provider;
